module.exports = __webpack_public_path__ + "img/logo.7c771c48.png";